import { render, staticRenderFns } from "./infoVersion.vue?vue&type=template&id=591d5d38&scoped=true&"
import script from "./infoVersion.vue?vue&type=script&lang=js&"
export * from "./infoVersion.vue?vue&type=script&lang=js&"
import style0 from "./infoVersion.vue?vue&type=style&index=0&id=591d5d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d5d38",
  null
  
)

export default component.exports